module.exports = __webpack_public_path__ + "img/completed.5712606d.svg";